module.exports = "./img/4ec2821b0c8c6f287632f451b8ab1bfa.jpg";